var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  blackoutdatesCollection.push([2026, 1, 14, 'inverted']);
  picker.set('disable', blackoutdatesCollection);
}

var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log(selectedDay, selectedDate, selectedMonth);  
  if(selectedDate.getDate() === 14 && selectedMonth === 1 && selectedDate.getFullYear() === 2026) {
    timepicker.set('min',[10, 0]); 
    timepicker.set('max',[15, 0]); 
  }
}